import React from "react";
import { FinancingPlan } from "tsi-common-react/src/models/financing";
import { getPageSetting } from "tsi-common-react/src/utils/settings";

interface IProps {
    plans: readonly FinancingPlan[];
}

export const BasketFinePrint = ({
    plans,
}: IProps): React.JSX.Element | null => {
    if (plans.length <= 0) {
        return null;
    }
    return (
        <div
            id="basket-lines__fine-print"
            className="basket-lines__fine-print"
            dangerouslySetInnerHTML={{
                __html: getPageSetting("basket_financing_fine_print") || "",
            }}
        ></div>
    );
};
